const root = 'importList-importListProduct'
const pricingTab = `${root}-pricingTab`
const variantRow = `${root}-variantRow`

export const TestId = {
  priceLockSwitch: `${pricingTab}-priceLockSwitch`,
  variantRow,
  variantImage: `${variantRow}-variantImage`,
  variantOptionNamesCell: `${variantRow}-optionNamesCell`,
  variantCompareAtPriceCell: `${variantRow}-compareAtPriceCell`,
  variantPriceCell: `${variantRow}-priceCell`,
  variantCost: `${variantRow}-cost`,
  variantShipping: `${variantRow}-shipping`,
  variantProfit: `${variantRow}-profit`,
}
